/*
THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE THANK YOU PAGE
*/

import React, { useEffect, useState } from 'react';
import './ThankYou.css';
import { useSelector, useDispatch } from 'react-redux';
import CheckCircleOutlineSharpIcon from '@material-ui/icons/CheckCircleOutlineSharp';
import HelpIcon from '@material-ui/icons/Help';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

const ThankYou = () => {
  
  const cart = useSelector(state => state.cartReducer);

  useEffect(() => {
    data()
  }, [])

  const { t, i18n } = useTranslation();

  const data = async () => {
  };

  return (
    <div className="ThankYouContainer">   
      <Grid container spacing={3}>
        <Grid item xs={2}><CheckCircleOutlineSharpIcon color="primary" style={{ fontSize: 60 }}/></Grid>
        <Grid item xs={10}>
          <h3  className="ThankYouTitle">{`${t("Thank you")} ${cart.shipping_address.first_name}!`}</h3>
          <span>Order</span>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className="GridContent">
            <h4>{t("Your order is confirmed")}</h4>
            <p className="text-muted">{`${t("We've accepted your order, and we're getting it ready. A confirmation email has been sent to")} ${cart.customer.email}.`}</p>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item md={6} xs={12}>
          <div className="GridContent">
            <h4>{t("Customer Information")}</h4>
            <span>{cart.customer.email}</span> <br/>
            <h4>{`${t("Shipping")} ${t("Address")}`}</h4>
            <span>{cart.shipping_address.first_name + ' ' + cart.shipping_address.last_name}</span> <br/>
            <span>{cart.shipping_address.company}</span> <br/>
            <span>{cart.shipping_address.address1}</span> <br/>
            <span>{cart.shipping_address.address2}</span> <br/>
            <span>{cart.shipping_address.city + ' ' + cart.shipping_address.province_code + ' ' + cart.shipping_address.zip}</span> <br/>
            <span>{cart.shipping_address.phone}</span> <br/>  
          </div>
        </Grid>
        <Grid item md={6} xs={12}>
          <div className="GridContent">
            <h4>{t("Payment method")}</h4>
            <span>{cart.payment.option_code}</span> <br/>
            <h4>{t("Billing Address")}</h4>
            <span>{cart.billing_address.first_name + ' ' + cart.billing_address.last_name}</span> <br/>
            <span>{cart.billing_address.company}</span> <br/>
            <span>{cart.billing_address.address1}</span> <br/>
            <span>{cart.billing_address.address2}</span> <br/>
            <span>{cart.billing_address.city + ' ' + cart.billing_address.province_code + ' ' + cart.billing_address.zip}</span> <br/>
            <span>{cart.billing_address.phone}</span> <br/>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className="GridContent">
            <h4>{t("Shipping method")}</h4>
            <span>Service: {cart.delivery.option_code}</span> <br/>
            <span>{t("Date")}: {cart.delivery.date} ({cart.delivery.day_code})</span> <br/>
            <span>{t("Time")}: {cart.delivery.time_window_code}</span> <br/>
            <span>{("Shipping Fee")}: {cart.delivery.fee.price } ({cart.delivery.fee.title}) </span> <br/>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={6}>
          <HelpIcon/>
          <span className="text-muted">{t("Need help?")}</span>
          <a href="mailto:info@epanneur.ca">{t("Contact us")}</a>
        </Grid>
        <Grid item xs={6}>
          <a href="{config.link_store_home}">{t("Continue shopping")}</a>
        </Grid>
      </Grid>

    </div>
  )   
}

export default ThankYou;
